import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { UserManagementServiceService } from 'src/app/admin/user-management/user-management-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { ActivatedRoute , Router} from '@angular/router';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-ipsa-report',
  templateUrl: './ipsa-report.component.html',
  styleUrls: ['./ipsa-report.component.scss']
})
export class IpsaReportComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private userManagementService: UserManagementServiceService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    const pageAction = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
    const currentBaseProgramForm = this.getCurrentProgramFormMethod(pageAction[0]);

    this.allowedAction = pageAction[0].authenicationJson.filter((el: any) => {
    if (el?.model === currentBaseProgramForm.model) { return el; }
  });
    this.createUserForm();
    this.getCountryDetails();
    this.reportList();
  }


  get f(): any {
    return this.userForm.controls;
  }
  @ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger | undefined;
  public userForm !: FormGroup ;
  countrys: any = [];
  sectorNames: any = [];
  msmeNames: any = [];
  userRoles: any = [];
  userId = '';
  adminData: any = JSON.parse(sessionStorage.getItem('userdata') || '{}');
  showCountryDropdown = false;
  selectedCountry: any;
  totalDataCount = 0;
  public limit = 10;
  public skip = 0;
  public page = 1;

  headings: any = [{
    label: 'Year',
    key: 'year'
  },
  {
    label: 'Country',
    key: 'country_name'
  },
  {
    label: 'Sector',
    key: 'sector_name'
  },
  {
    label: 'Msme',
    key: 'msme_name'
  }];

  years = [
    {
      year: '2022',
      value: '2022'
    },
    {
      year: '2023',
      value: '2023'
    },
    {
      year: '2024',
      value: '2024'
    },
  ];

  countryCodeArray = [
    {
      name: 'Ethiopia',
      id: '5',
      code: '251'
    },
    {
      name: 'Vietnam',
      id: '6',
      code: '84'
    },
    {
      name: 'Kenya',
      id: '4',
      code: '254'
    },
  ];
  userAllData: any;
  userEmailId = '';
  isNodataFound = false;
  sortSelection: any;
  orderSorting = '';
  selectedColumn = '';
  filterParams: any;

  baseFormModule: string[] = ['ipsa'];
  allowedAction: any = [];

  @ViewChild('userRole') select: MatSelect | undefined;
  @ViewChild('paginator') paginator: MatPaginator | undefined;

reportTable: any = [];

  preventKeyboardInput(event: KeyboardEvent): void {
    if (event) {
    return;
    }
  }

  ngOnInit(): void {

    this.userId = this.route.snapshot.params.id;
    if (this.userId){
      setTimeout(() => {
      }, 1000);
    }
  }
  createUserForm(): void {
    this.userForm = this.formBuilder.group({
        year: [''],
        sectorId: [''],
        countryId: [''],
        msmeId: [''],
    });
}

  async getCountryDetails(): Promise<void> {
   await this.userManagementService.countryDetails().subscribe((res: any) => {
      if (res.success){
        this.countrys = res.data;
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '');
    });

  }
  async getSectorNameDetails(data: any = [], selectedCountryId: string): Promise<void> {

   await this.userManagementService.sectorNameDetails(selectedCountryId).subscribe((res: any) => {
      if (res?.success){
        if (this.countrys?.length){
          this.sectorNames = res?.data;
        }
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '');
    }, () => {
      if (this.userId){
        if (data[0].country_id && data[0].sector_id && !data[0].msme_id){
        }
      }
    });

  }
  async getMsmeNameDetails(data: any = [], seleectedId: string): Promise<void> {
   await this.userManagementService.msmeNameDetails(seleectedId).subscribe((res: any) => {
      if (res.success){
        if (this.sectorNames?.length){
          this.msmeNames = res.data;
        }
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '');
    }, () => {
      if (this.userId){
      }
    });
  }


  createUser(): void {
    if (this.userForm?.invalid){
      this.openSnackBar(['All field are required !!'], '', 'warning');
    }

  }

  countryChangeHandler(event: MatSelectChange): void {
    this.selectedCountry = event.value.id;

    if (event?.value?.id){
      this.getSectorNameDetails('', event?.value?.id);
      this.sectorNames = [];
      this.msmeNames = [];
      this.userForm.patchValue({
        sectorId: [],
        msmeId: []
      });
    }
  }
  sectorChangeHandler(event: MatSelectChange): void {
    if (event?.value?.id){
      this.getMsmeNameDetails('', event?.value?.id);
      this.msmeNames = [];
      this.userForm.patchValue({
        msmeId: []
      });
    }
  }
  openSnackBar(message: any, action = '', className= 'parmary'): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    panelClass: [className]
  });
}

numberOnly(event: any): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

resetFilter(): void {
  this.userForm.reset();
  this.search();
}


search(): void {
  this.selectedColumn = '';
  this.filterParams = '';
  if (this.matMenuTrigger) {

    this.matMenuTrigger.closeMenu();
  }
  let filterParams: any = `?`;
  for (const key in this.userForm.value){
    if (this.userForm.value[key]){
    let value = this.userForm.value[key];
    if (key !== 'year' && this.userForm.value[key].hasOwnProperty('id')) {
    value = this.userForm.value[key].id;
    }
    if (filterParams.length > 1){
        filterParams += `&`;
      }
    if (value) {
    filterParams += `${key}=${value}`;
    }
    }
  }
  this.filterParams = filterParams;
  if (filterParams) { this.paginator?.firstPage(); }
  this.reportList();
}

async reportList(sortColumn: any = ''): Promise<void> {
  let filterParams = this.filterParams ? this.filterParams : '';
  filterParams += filterParams ? `&` : `?`;
  filterParams += `limit=${this.limit}`;
  filterParams += `&page=${this.page}`;
  if (filterParams){
    filterParams += sortColumn ? `&${sortColumn}` : ``;
  }else{
    filterParams += sortColumn ? `?${sortColumn}` : ``;
  }
  await this.userManagementService.ipsaReportList(filterParams).subscribe((res: any) => {
     if (res.success){
       this.reportTable = res.data;
       if (this.reportTable.length === 0) { this.isNodataFound = true; }
       else { this.isNodataFound = false; }
       this.totalDataCount = res.total;
     }
   }, (error: any) => {
     this.openSnackBar([error?.message || 'Failed !'] , '');
   });

 }

 downloadReport(item: any, type: any): void {
   const payload: any = JSON.stringify({
    year: item?.year,
    countryId: item?.countryId,
    sectorId: item?.sectorId,
    msmeId: item?.msmeId,
    versionFlag: type === 'with' ? true : false
});
   this.userManagementService.ipsaReportDownload(payload, item);

 }

 setPage(event: any): void {
  this.skip = (event.pageIndex + 1) * this.limit - this.limit;
  this.limit = event.pageSize;
  this.page = event.pageIndex + 1;
  this.reportList();
}

isEmptyString(): boolean {
  let isEmptyString = true;
  for (const key in this.userForm.value){
    if (this.userForm.value[key]){
      isEmptyString = false;
    }
  }
  return isEmptyString;
}

sortTable(columnName: string, sortType: string = ''): void {
  this.sortSelection = sortType;
  this.selectedCountry = columnName;
  this.selectedColumn = columnName;
  this.orderSorting = sortType === 'down' ? 'DESC' : 'ASC';
  const sortColumn = `${columnName}=${this.orderSorting}`;
  this.reportList(sortColumn);
}

backToPrism(): void {
  this.router.navigate(['/prism']);
}

getCurrentProgramFormMethod(data: any): any {
  let getCurrentTab: any = null;

  this.baseFormModule.some((el: any) => {
    getCurrentTab = data.authenicationJson.find((e: any) => {
      return e.model === el &&
        (e.isAction || e.is_checked || (e.authentication && e.authentication.some((inside: any) => inside.isAction)));
    });

    return getCurrentTab !== undefined;
  });

  return getCurrentTab;
}

}
